/**
 * @namespace helpers
 */

/**
 * Helper functions for Strings
 *
 * @module string
 * @memberof helpers
 * @see helpers
 */

/**
 * Function that replaces regular spaces with non-breaking ones
 *
 * @function
 * @param {String} str
 * @return {String}
 */
export const nbspify = (str) => str.replace(/\s/g, '\u00A0')

/**
 * Function that replaces regular spaces with non-breaking ones
 *
 * @function
 * @param {String} chars
 * @param {Number} min
 * @param {Number} max
 * @return {String}
 */
export const getRandomString = function (chars, min, max) {
  const letters = chars.split('')
  let code = ''
  const rand = (min - 0.5) + Math.random() * (max - min + 1)
  const count = Math.round(rand)
  for (let i = 0; i < count; i++) {
    code += letters[Math.floor(Math.random() * letters.length)]
  }
  return code
}

/**
 * Function that tacking only text nodes
 *
 * @function
 * @param {String} str
 * @return {String}
 */
export const getTextNodesContent = (str) => {
  const el = document.createElement('DIV')
  el.innerHTML = str
  return Array.prototype.map.call(
    el.childNodes,
    node => node.nodeName === '#text' ? node.nodeValue : ''
  ).join('').replace(/\s+/g, ' ').trim()
}

/**
 * Get unique link. Disable cache
 *
 * @function
 * @param {String} link
 * @return {String}
 */
export const getUniqueLink = (link = '') => {
  if (!angular.isString(link)) {
    return ''
  }
  return !link.includes('timestamp') ? `${link}?timestamp=${+new Date()}` : link
}
